import React, { useState } from 'react';

import DataTableContainer from '../../components/DataTableContainer';
import MyDataTable from '../../components/MyDataTable';
import { ServerFarmInterface, streamServersService, TimelineProvider } from '../../services/central-api/stream-servers';
import { translate } from '../../services/translate';
import { View } from 'react-native';
import Badge from '../../components/Badge';
import DropdownButton from '../../components/DropdownButton';
import ConfirmModal from '../../components/ConfirmModal';
import moment from 'moment';

interface ServerFarmDetailTimelineProvidersParams {
    serverFarm: ServerFarmInterface;
    setServerPoolId: (serverPoolId: string | null) => void;
    setTimelineProviderId: (timelineProviderId: number | null) => void;
    setVideoStorageProviderId: (videoStorageProvider: number | null) => void;
    setSelectedTab: (selectedTab: 'serverPools' | 'timelineProviders' | 'videoStorageProviders' | 'servers' | null) => void;
    refetch: () => void;
}

export default function ServerFarmDetailTimelineProviders(params: ServerFarmDetailTimelineProvidersParams) {
    const [isModalVisible, setModalVisible] = useState(false);
    const [selectedTimelineProvider, setSelectedTimelineProvider] = useState<TimelineProvider | null>(null);

    return (<>
        <DataTableContainer
            dataTable={<MyDataTable
                data={params.serverFarm.timelineProviders}
                pointerOnHover
                onRowClicked={(row) => {
                    params.setServerPoolId(null);
                    params.setTimelineProviderId(row.id);
                    params.setVideoStorageProviderId(null);
                    params.setSelectedTab(null);
                }}
                columns={[{
                    name: translate('id'),
                    cell: row => row.id,
                    minWidth: '75px',
                    grow: 0,
                }, {
                    name: translate('type'),
                    selector: row => row.timelineType,
                }, {
                    name: translate('name'),
                    selector: row => row.tableName,
                }, {
                    name: translate('createdAt'),
                    selector: row => moment(row.createdAt).format('DD/MM/YYYY HH:mm'),
                }, {
                    name: translate('servers'),
                    selector: row => row.serverCount,
                    center: true,
                }, {
                    name: translate('defaultForServers'),
                    cell: row => {
                        if (row.id === params.serverFarm.defaultTimelineProviderId) {
                            return <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                                <Badge mode='SQUARE' key={row.id} color='green'>
                                    {translate('defaultForNewServers')}
                                </Badge>
                            </View>;
                        }

                        return <></>;
                    },
                    wrap: true,
                }, {
                    name: '',
                    button: true,
                    wrap: true,
                    cell: (row) => {
                        return (
                            <DropdownButton
                                size={320}
                                offsetX={-168}
                                actions={[{
                                    content: translate('setAsDefault'),
                                    omit: row.id === params.serverFarm.defaultTimelineProviderId,
                                    onPress: () => {
                                        setSelectedTimelineProvider(row);
                                        setModalVisible(true);
                                    },
                                }]}
                            />
                        );
                    }
                }]}
            />}
        />
        <ConfirmModal
            maxWidth={400}
            setModalVisible={setModalVisible}
            isModalVisible={isModalVisible}
            customMessage={translate('setTimelineProviderAsDefault', {
                timelineProvider: `${selectedTimelineProvider?.id} - ${selectedTimelineProvider?.timelineType} - ${moment(selectedTimelineProvider?.createdAt).format('DD/MM/YYYY')}`,
            })}
            customConfirm={translate('confirm')}
            onSubmit={async () => {
                try {
                    if (!selectedTimelineProvider) {
                        return;
                    }
                    await streamServersService.setTimelineProviderAsDefault(selectedTimelineProvider.id);
                    params.refetch();
                } catch (err) {
                    console.error(err);
                }
            }}
            onCancel={() => {
                setSelectedTimelineProvider(null);
            }}

        />
    </>);
}
